import React from 'react';
import './Footer.css';
import facebookLogo from '../Assets/Facebook_Logo_Primary.png';
import instagramLogo from '../Assets/Instagram_Glyph_Black.png';
import ttLogo from '../Assets/TikTok_Icon_Black_Square.png';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Friends of Roosevelt High School Rowing. All rights reserved.</p>
      <div className="social-links">
        <a href="https://www.facebook.com/profile.php?id=100057528674923" target="_blank" rel="noopener noreferrer">
          <img src={facebookLogo} alt="Facebook" className="social-icon" />
        </a>
        
        <a href="https://www.instagram.com/wyandotterowing/" target="_blank" rel="noopener noreferrer">
          <img src={instagramLogo} alt="Instagram" className="social-icon" />
        </a>
         <a href="https://www.tiktok.com/@wyandotterowing?_t=8ehRlsbumI2&_r=1&fbclid=PAZXh0bgNhZW0CMTEAAaePCBIjb9ZzQ_IpvXOSVg-IpWpR3-1ETq3HXu4NowjZv4sOSIe7gdPBIXq3Yw_aem_AfVn6nADtTAZFkIc1AnJXQ" target="_blank" rel="noopener noreferrer">
          <img src={ttLogo} alt="TikTok" className="social-icon" />
        </a>
      </div>
    </footer>
  );
}

export default Footer;